import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    position: "relative",
  },
  rootTabs: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 15,
  },
  appBar: {
    position: "relative",
  },
  title: {
    flex: 1
  },
});
